<template>
  <div
    data-qa="card_getting_club_enter"
  >
    <div
      class="text-h6 text--text"
      data-qa="card_getting_club_enter_title"
    >
      Вы не в клубе
    </div>
    <div
      class="text-body-1 text--text mt-3"
      data-qa="card_getting_club_enter_description"
    >
      Клубная карта даёт доступ к ценам ниже
      <br>на 30% на приёмы врачей и {{ discountOnServices }}% на услуги
      <br>в клиниках клуба
    </div>
    <div
      class="club-card-offer text-body-1 text--text"
      data-qa="card_getting_club_enter_offer"
    >
      <div class="d-flex align-center justify-space-between mb-1">
        <span data-qa="card_getting_club_enter_offer_title">
          Карта на 6 месяцев
        </span>
        <span
          v-if="clubData.cardNextPrice"
          class="text-subtitle-1"
          data-qa="card_getting_club_enter_offer_price"
        >
          {{ clubData.cardNextPrice }} {{ currency.symbol }}
        </span>
        <v-img
          v-else
          contain
          width="24"
          height="25"
          class="flex-grow-0"
          data-qa="card_getting_club_enter_offer_present"
          src="/static/_v1/pd/icons/emoji/wrapped-present.png"
          alt="Иконка подарок"
        />
      </div>
      <div
        class="text-body-2 text-secondary--text"
        data-qa="card_getting_club_enter_offer_description"
      >
        Это не подписка. Вы сами решаете, покупать
        <br>новую клубную карту или нет.
      </div>
    </div>
    <v-btn
      block
      color="primary"
      class="mt-6 mb-2"
      :elevation="0"
      data-qa="card_getting_club_enter_submit"
      @click="handleClickSubmit"
    >
      {{ variationBtnText }}
    </v-btn>
    <div class="text-body-2 text-secondary--text text-center">
      Нажимая на кнопку, вы даете согласие <br>
      <a
        target="_blank"
        href="/info/privacy-policy/"
        class="primary--text text-decoration-none"
      >на обработку персональных данных</a>,
      <a
        target="_blank"
        href="/info/terms-of-use/"
        class="primary--text text-decoration-none"
      >принимаете пользовательское соглашение</a> и соглашаетесь <br> с
      <a
        target="_blank"
        href="/static/_v1/pd/documents/pdf/club/Правила_использования_купонов.pdf"
        class="primary--text text-decoration-none"
      >офертой</a> и
      <a
        target="_blank"
        href="/static/_v1/pd/documents/pdf/club/Правила_участия_в_клубе_ПроДокторов.pdf"
        class="primary--text text-decoration-none"
      >правилами клуба</a>.
    </div>
    <v-btn
      text
      block
      class="mt-2"
      data-qa="card_getting_club_enter_cancel"
      @click="$emit(events.club.cardGettingCancel)"
    >
      Отменить
    </v-btn>
  </div>
</template>

<script>
import {
  eventsData,
  getClubData,
} from 'www/vue_components/common/Club/components/core/ClubCardGetting/interfaces'

import CurrencyData from 'www/vue_components/common/mixins/CurrencyData'

export default {
  name: 'ClubCardGettingClubEnter',
  mixins: [
    CurrencyData,
  ],
  props: {
    clubData: {
      type: Object,
      default: getClubData,
    },
  },
  data: () => ({
    events: eventsData,
    discountOnServices: window.USER.club.discountOnServices,
  }),
  computed: {
    variationBtnText() {
      return this.clubData.cardNextPrice ? `Оплатить ${this.clubData.cardNextPrice} ${this.currency.symbol}` : 'Вступить'
    },
  },
  methods: {
    handleClickSubmit() {
      this.$emit(this.events.club.cardGettingSubmit)
    },
  },
}
</script>

<style scoped lang="scss">
.club-card-offer {
  margin-top: 24px;
  padding-left: 40px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    background: url('/static/_v1/pd/icons/ui-kit/club/club-percent.svg') no-repeat 50% 50% / contain;
  }
}
</style>
